export const MicrosoftIcon = () => (
  <svg
    className='w-5 h-5'
    viewBox='0 0 23 23'
    xmlns='http://www.w3.org/2000/svg'>
    <rect width='10' height='10' x='1' y='1' fill='#F35325' />
    <rect width='10' height='10' x='12' y='1' fill='#81BC06' />
    <rect width='10' height='10' x='1' y='12' fill='#05A6F0' />
    <rect width='10' height='10' x='12' y='12' fill='#FFBA08' />
  </svg>
);
